import React, { Component } from 'react';
import $ from 'jquery';
import DataTablesCreate from "./DataTablesCreate";
import {ApiClient} from "../libs/apiClient";
import {BankAccountModel} from './NewOrder';
import {
    BankModal,
} from "./index";

let headers = [
    {title: 'Código bancario'},//0
    {title: 'País'},//1
    {title: 'ID Bancaria interna'},//2
    {title: 'Número de cuenta'},//3
    {title: 'Nombre de cuenta bancaria'},//4
    {title: 'IND int.ctrl.'},//5
    {title: 'Sucursal'},//6
    {title: 'IBAN'},//7
    {title: 'Código BIC/SWIFT'},//8
    {title: 'ID de mandato'},//9
    {title: 'Fecha de la firma'},//10
    {title: 'Calle'},//11
    {title: 'Número de la calle'},//12
    {title: 'Código postal'},//13
    {title: 'Bloque'},//14
    {title: 'Ciudad'},//15
    {title: 'Condado'},//16
    {title: 'Usuario número 1'},//17
    {title: 'Usuario número 2'},//18
    {title: 'Usuario número 3'},//19
    {title: 'Usuario número 4'},//20
];

let apiClient = ApiClient.getInstance();
class BankAccountModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            listBanks: [],
        };
    }
    componentDidMount() {
        this.closeAction();
    }

    closeAddress = async () => {
        $('#bankAccountModal').modal('hide');
    }

    closeAction = () => {
        const { cleanData } = this.props;
        $('#bankAccountModal').on('hidden.bs.modal', function () {
            cleanData();
        });
    };
    openBanks = async () => {
        const {showAlert, partnerModel, enableSpinner} = this.props;

        enableSpinner(true);
        let response = await apiClient.getBanks();
        enableSpinner(false);

        if (!Array.isArray(response.data)) {
            showAlert({type: 'error', message: 'Ocurrió un error al consultar la Información'});
            return;
        }
        if (response.data.length === 0) {
            showAlert({type: 'info', message: 'No hay Información por mostrar'});
            return;
        }
        
        this.setState({
            listBanks: response.data,
        });
        
        $('#bankModal').modal('show');
    };

    selectBank = (bank)=>{
        const {partnerModel,refreshModel} = this.props;
        const newBankModel = new BankAccountModel();

        newBankModel.AbsEntry = bank.AbsEntry; // 4
        newBankModel.Country = bank.Name; //Mexico
        newBankModel.BankCode = bank.BankCode; // 015
        newBankModel.BankName = bank.BankName; //BBVA
        newBankModel.CountryCod = bank.CountryCod; //Mx

        partnerModel.BankAccounts.push(newBankModel);
        refreshModel(partnerModel);
        $('#bankModal').modal('hide');
    }
    
    render() {
        const {listBanks} = this.state;
        const {partnerModel,deleteBank,selectBankDefault,changeAccountBank, changeControlKeyBank, changeBranchBank, changeIBANBank, changeSwiftNumBank} = this.props;
        // if(data.length === 0){
        //     return <div className="modal fade bd-example-modal-lg bgtransparent"  role="dialog"  id="addressesModal"></div>;
        // }
        let data = partnerModel.BankAccounts ? partnerModel.BankAccounts.length > 0 ? partnerModel.BankAccounts  : [] : [];

        return (
            <div>
                <div className="modal fade bd-example-modal-lg bgtransparent"  role="dialog"  id="bankAccountModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <BankModal 
                    data = {listBanks}
                    action = {this.selectBank}
                />
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">

                            <div className="modal-header text-white" style={{backgroundColor:'#343a40',borderRadius:'0'}}>
                                <h4 className="modal-title" id="modal-basic-title ">Cuentas bancarias de  socio de negocios - Definiciones</h4>
                                <button type="button" className="close" onClick={this.closeAddress} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body" >
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            <div className="w-100 table-scroll tab-pane fade show active " aria-labelledby="nav-home-tab-Contenido" >
                                                <table className="table" style={{marginBottom: 0}}>
                                                    <thead className="table-header-yellow">
                                                        <tr style={{textAlign: "center"}}>
                                                            <td className=" sticky-column sticky-header" style={{maxWidth:300, backgroundColor: '#d2ab24'}}>
                                                                
                                                            </td>
                                                            <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                                                Código bancario
                                                            </td>
                                                            <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                                                Nombre del Banco
                                                            </td>
                                                            <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                                                ID Bancaria interna
                                                            </td>
                                                            <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                                                Número de cuenta.
                                                            </td>
                                                            <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                                                IND int.ctrl.
                                                            </td>
                                                            <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                                                Sucursal
                                                            </td>
                                                            <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                                                IBAN
                                                            </td>
                                                            <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                                                Código BIC/SWIFT
                                                            </td>
                                                            {/* <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                                                ID de mandato
                                                            </td>
                                                            <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                                                Fecha de la firma
                                                            </td>
                                                            <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                                                Calle
                                                            </td>
                                                            <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                                                Número de la calle
                                                            </td>
                                                            <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                                                Código postal
                                                            </td>
                                                            <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                                                Bloque
                                                            </td>
                                                            <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                                                Ciudad
                                                            </td>
                                                            <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                                                Condado
                                                            </td>
                                                            <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                                                Usuario número 1
                                                            </td>
                                                            <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                                                Usuario número 2
                                                            </td>
                                                            <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                                                Usuario número 3
                                                            </td>
                                                            <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                                                Usuario número 4
                                                            </td> */}
                                                            <td className="sticky-header table-header-yellow " style={{width:100}}></td>
                                                            <td
                                                                className="sticky-header sticky-columns"
                                                                style={{backgroundColor: '#d2ab24'}}
                                                            />
                                                        </tr>
                                                    </thead>
                                                    
                                                    <tbody>
                                                    
                                                        {data.map((register, index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    {/* Seleccionar cuenta default */}
                                                                    <td style={{textAlign:"center", width:100}}>
                                                                        <button type="button" className="btn btn-sm "
                                                                                 onClick={() => selectBankDefault(register)}
                                                                                style={{fontWeight: '500', backgroundColor: "transparent", color: "#EABF28"}}>
                                                                            <i className="fas fa-check"></i>
                                                                        </button>
                                                                    </td>
                                                                    {/* Codigo de Banco */}
                                                                    <td>{register.BankCode}</td>
                                                                    {/* Nombre del banco */}
                                                                    <td>{register.BankName}</td>
                                                                    {/* IDBancaria Interna */}
                                                                    <td>{register.AbsEntry}</td>

                                                                    {/* Numero de Cuenta */}
                                                                    <td>
                                                                        <input
                                                                            type=" text"
                                                                            className=" form-control validarCant cantBlur btn-outline-secondary"
                                                                            style={{
                                                                                backgroundColor: 'transparent',
                                                                                borderColor: '#ced4da',
                                                                                color: '#000',
                                                                                paddingTop: 1,
                                                                                paddingBottom: 2,
                                                                                maxWidth: 100,
                                                                                textAlign: "center",
                                                                                
                                                                            }}
                                                                            id={'Accoutn' + index}
                                                                            value={register.Account || ''}
                                                                            onChange={event => changeAccountBank(register,event )}
                                                                        />
                                                                    </td>
                                                                    {/* IND INT.CTL */}
                                                                    <td>
                                                                        <input
                                                                            type=" text"
                                                                            className=" form-control validarCant cantBlur btn-outline-secondary"                                                                           style={{
                                                                                backgroundColor: 'transparent',
                                                                                borderColor: '#ced4da',
                                                                                color: '#000',
                                                                                paddingTop: 1,
                                                                                paddingBottom: 2,
                                                                                maxWidth: 100,
                                                                                textAlign: "center",

                                                                            }}
                                                                            id={'BankCtl' + index}
                                                                            value={register.ControlKey || ''}
                                                                            onChange={event => changeControlKeyBank(register,event )}
                                                                        />
                                                                    </td>
                                                                    {/* Sucursal */}
                                                                    <td>
                                                                        <input
                                                                            type=" text"
                                                                            className=" form-control validarCant cantBlur btn-outline-secondary"                                                                            style={{
                                                                                backgroundColor: 'transparent',
                                                                                borderColor: '#ced4da',
                                                                                color: '#000',
                                                                                paddingTop: 1,
                                                                                paddingBottom: 2,
                                                                                maxWidth: 100,
                                                                                textAlign: "center",

                                                                            }}
                                                                            id={'Branch' + index}
                                                                            value={register.Branch || ''}
                                                                            onChange={event => changeBranchBank(register,event )}
                                                                        />
                                                                    </td>
                                                                    {/* IBAN */}
                                                                    <td>
                                                                        <input
                                                                            type=" text"
                                                                            className=" form-control validarCant cantBlur btn-outline-secondary"
                                                                            style={{
                                                                                backgroundColor: 'transparent',
                                                                                borderColor: '#ced4da',
                                                                                color: '#000',
                                                                                paddingTop: 1,
                                                                                paddingBottom: 2,
                                                                                maxWidth: 100,
                                                                                textAlign: "center",

                                                                            }}
                                                                            id={'IBAN' + index}
                                                                            value={register.IBAN || ''}
                                                                            onChange={event => changeIBANBank(register,event )}
                                                                        />
                                                                    </td>
                                                                    {/* CODIGO BIC/SWIFT */}
                                                                    <td>
                                                                        <input
                                                                            type=" text"
                                                                            className=" form-control validarCant cantBlur btn-outline-secondary"
                                                                            style={{
                                                                                backgroundColor: 'transparent',
                                                                                borderColor: '#ced4da',
                                                                                color: '#000',
                                                                                paddingTop: 1,
                                                                                paddingBottom: 2,
                                                                                maxWidth: 100,
                                                                                textAlign: "center",

                                                                            }}
                                                                            id={'SWIFT' + index}
                                                                            value={register.SwiftNum || ''}
                                                                            onChange={event => changeSwiftNumBank(register,event )}
                                                                        />
                                                                    </td>
                                                                    {/* Eliminar banco */}
                                                                    <td style={{textAlign:"center", width:100}}>
                                                                        <button type="button" className="btn btn-sm"
                                                                                onClick={()=>deleteBank(register)}
                                                                                style={{fontWeight: '500', backgroundColor: "transparent", color: "#EABF28"}}>
                                                                            <i className="fas fa-trash-alt"></i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })}
                                                        <tr>
                                                            <td className="sticky-column" style={{backgroundColor: '#FFF', textAlign: 'center'}}>
                                                                <div>
                                                                    {/* <input
                                                                        type=" text"
                                                                        placeholder="Código bancario"
                                                                        className=" form-control validarCant cantBlur btn-outline-secondary"
                                                                        style={{
                                                                            backgroundColor: 'transparent',
                                                                            color: '#000',
                                                                            paddingTop: 1,
                                                                            paddingBottom: 2,
                                                                        }}
                                                                        onKeyPress={(ev) => {                           
                                                                            if (ev.key === 'Enter') { 
                                                                            this.openBanks();
                                                                            
                                                                            }
                                                                        }}
                                                                        // value={ newOrderModel.searchItem || ''}
                                                                        onChange={event => this.changeSearchItem(event)}
                                                                    /> */}
                                                                    <button
                                                                        type="button"
                                                                        style={{
                                                                            backgroundColor: 'transparent',
                                                                            padding: 5,
                                                                            color: 'green',
                                                                            paddingTop: 2,
                                                                            paddingBottom: 2,
                                                                        }}
                                                                        className="btn"
                                                                        onClick={this.openBanks}>
                                                                        <i className="fa fa-plus-circle" aria-hidden="true" size="10"/>
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closeAddress}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default BankAccountModal;